import { NavLink, useHistory } from "react-router-dom";
import { defaultImg } from "../../utils/helper";
import classnames from "classnames";
import "./Burger.scss";

const Burger = ({
  loginCheck,
  userData,
  scrolled,
  setOpenModal,
  openBurger,
  setOpenBurger,
}) => {
  const history = useHistory();
  const analysis = history.location.pathname.length > 1;

  return (
    <article className="burger">
      <div
        className="burger__container"
        onClick={() => setOpenBurger(!openBurger)}
      >
        <span
          className={`burger__line ${openBurger ? "burger__line--top" : ""} ${
            scrolled || analysis || openBurger ? "burger__line--scrolled" : ""
          }`}
        ></span>
        <span
          className={`burger__line ${openBurger ? "burger__line--hide" : ""} ${
            scrolled || analysis || openBurger ? "burger__line--scrolled" : ""
          }`}
        ></span>
        <span
          className={`burger__line ${
            openBurger ? "burger__line--bottom" : ""
          } ${
            scrolled || analysis || openBurger ? "burger__line--scrolled" : ""
          }`}
        ></span>
      </div>
      <ul
        className={classnames("burger__list", {
          "burger__list--open": openBurger,
          "burger__list--scrolled": scrolled,
          "burger__list--top-minus-5px": analysis,
        })}
      >
        <li className="burger__list-item" onClick={() => setOpenBurger(false)}>
          <NavLink to="/"> HOME</NavLink>
        </li>
        <li
          className={`burger__list-item`}
          onClick={() => {
            // check if logged in, if not redirect to log in page
            loginCheck(false, userData, history);
            setOpenBurger(false);
          }}
        >
          {/* <div className={`burger__beta`}>New AI Features</div> */}
          SCHEDULE A POST
        </li>
        <li className="burger__list-item" onClick={() => setOpenBurger(false)}>
          <a
            href="mailto: eureka.inquiry@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            CONTACT
          </a>
        </li>
        {userData.username !== null && (
          <li
            className={
              "navbar__list-item navbar__list-item--purple burger__username"
            }
            onClick={() => {
              setOpenBurger(false);
              setOpenModal(true);
            }}
          >
            <article className="navbar-login">
              <img
                src={userData.icon_img}
                onError={(e) => (e.currentTarget.src = defaultImg)}
                alt="reddit user icon"
                className="navbar-login__img"
              />{" "}
              <span className="navbar-login__username ">
                {userData.username}
              </span>
            </article>
          </li>
        )}
      </ul>
    </article>
  );
};

export default Burger;
